<template>
  <div class="main-container">
    <pageTitle
      pageTitle="指令生成"
      pageComment="通过编码内容快速生成常用指令，如 SS DOCS 指令。"
    ></pageTitle>
    <div class="main-content">
      <el-row>
        <el-col class="row" :span="24"
          ><el-button type="primary" plain @click="generateSsNn"
            >SS 指令-NN</el-button
          ><el-button type="primary" plain @click="generateSsLl"
            >SS 指令-LL</el-button
          ><el-button type="primary" plain @click="generateSsY"
            >SS 指令-Y 舱</el-button
          ><el-button type="primary" plain @click="generateBooking"
            >全预订指令</el-button
          ></el-col
        ></el-row
      >
      <el-row :gutter="24"
        ><el-col :span="12"
          ><el-form>
            <el-row
              ><el-col :span="24">
                <el-form-item prop="name"
                  ><el-input
                    type="textarea"
                    :rows="20"
                    v-model="data.pnrContent"
                    placeholder="请输入编码内容"
                  ></el-input>
                </el-form-item> </el-col
            ></el-row>

            <el-row
              ><el-col :span="12">
                <el-form-item label="延迟周数" label-width="120px"
                  ><el-select
                    v-model.number="data.weekNumber"
                    allow-create="true"
                    filterable
                  >
                    <el-option label="0 周" value="0"></el-option>
                    <el-option label="1 周" value="1"></el-option>
                    <el-option label="2 周" value="2"></el-option
                    ><el-option label="3 周" value="3"></el-option
                    ><el-option label="4 周" value="4"></el-option
                    ><el-option label="5 周" value="5"></el-option
                    ><el-option label="6 周" value="6"></el-option
                    ><el-option label="7 周" value="7"></el-option
                    ><el-option label="8 周" value="8"></el-option
                    ><el-option label="1 周" value="1"></el-option></el-select
                ></el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="乘客数" label-width="120px"
                  ><el-input-number
                    :min="1"
                    :max="9"
                    v-model.number="data.passengerCount"
                  />
                </el-form-item> </el-col></el-row></el-form></el-col
        ><el-col :span="12"
          ><el-input
            type="textarea"
            :rows="20"
            v-model="data.commandResult"
            placeholder="指令结果输出"
          ></el-input></el-col
      ></el-row>
    </div>
  </div>
</template>
<script>
import pageTitle from "@/components/mainTitle";
import { reactive, getCurrentInstance } from "vue";

export default {
  components: { pageTitle },
  setup() {
    const { proxy } = getCurrentInstance();
    let data = reactive({
      pnrContent: "",
      weekNumber: 0,
      commandResult: "",
      operate: "",
      passengerCount: 1,
    });
    function generateCommand(type) {
      if (data.pnrContent == "") {
        return;
      }
      data.operate = type;
      proxy.$http.post("/command/translate", data).then((response) => {
        if (response == null) {
          data.commandResult = "";
          return;
        }
        data.commandResult = response;
      });
    }
    function generateSsNn() {
      generateCommand("NN");
    }
    function generateSsLl() {
      generateCommand("LL");
    }
    function generateSsY() {
      generateCommand("Y");
    }
    function generateBooking() {
      generateCommand("");
    }
    return {
      data,
      generateCommand,
      generateSsNn,
      generateSsLl,
      generateSsY,
      generateBooking,
    };
  },
};
</script>
<style lang="scss" scoped>
.main-container {
  margin: -24px -24px 0 -24px;
}
.main-content {
  margin: 24px;
  padding: 24px;
  background-color: #fff;
}
.row {
  margin-bottom: 16px;
}
</style>